<template>
  <main :style="{ backgroundImage: `url(${meta.bg})`, backgroundSize: 'cover', backgroundPosition: 'center' }">
    <top-bar />
    <logo />

    <template v-show="loaded">
    <div class="pet-image-wrap">
      <img :src="info.petImage" alt="">
    </div>
    <div class="panel">
      <div class="item">
        <div class="ico-wrap">
          <img src="@/assets/owner.svg" alt="">
        </div>
        <span>{{ info.ownerNickname }}</span>
      </div>
      <div class="item">
        <div class="ico-wrap">
          <img src="@/assets/contact.svg" alt="">
        </div>
        <span>{{ info.contactNumber }}</span>
      </div>
      <div class="item pet-item">
        <div class="ico-wrap">
          <img src="@/assets/nickname.svg" alt="">
        </div>
        <span>{{ info.petNickname }}</span>
      </div>
      <div class="item pet-item">
        <div class="ico-wrap">
          <img src="@/assets/size.svg" alt="">
        </div>
        <span>{{ info.somatotype || '-' }}</span>
      </div>
      <div class="item pet-item">
        <div class="ico-wrap">
          <img src="@/assets/birthday.svg" alt="">
        </div>
        <span>{{ info.petBirthday || '-' }}</span>
      </div>
      <div class="item pet-item">
        <div class="ico-wrap">
          <img src="@/assets/breed.svg" alt="">
        </div>
        <span>{{ info.petBreed || '-' }}</span>
      </div>
      <div class="item pet-item">
        <div class="ico-wrap">
          <img src="@/assets/msg.svg" alt="">
        </div>
        <span>{{ info.specialNeeds || '-' }}</span>
      </div>
    </div>

    <div class="message-wrap">
      <span class="message">
        {{ $t('checked_info["Please contact my owner to help find me"]') }}
      </span>
    </div>
    </template>
  </main>
</template>

<script>
import meta from '../../utils/meta'
import axios from "../../utils/request";

export default {
  name: 'checked_info',
  data() {
    return {
      loaded: false,
      showDialog: false,
      confirmBtnLoading: false,
      info: {},
      meta
    }
  },
  mounted() {
    this.getDogInfo()
  },
  methods: {
    /**
     * @desc 上传弹框关闭事件
     */
    changeModel() {
      this.showDialog = false;
    },
    /**
     * @desc 确定按钮事件
     */
    confirmModel() {
      this.confirmBtnLoading = true;
      // 处理业务逻辑相关的代码
      this.confirmBtnLoading = false;
      this.showDialog = false;
    },
    getDogInfo() {
      const url = this.$route.query.id
        ? '/businese/dog_tag/getInfoByTagId?tagId=' + this.$route.query.id
        : '/businese/dog_tag/' + this.$route.params.petId
      axios(url).then(({code, data}) => {
        if (code === 200) {
          this.info = data
          this.loaded = true
        }
      })
    }
  }
}
</script>

<style scoped>
main {
  background-size: cover;
  text-align: center;
  position: relative;
  z-index: 1;
  padding: 3.73vw;
  width: 100vw;
  min-height: 100vh;
  box-sizing: border-box;
  background-attachment: fixed;
}

.pet-image-wrap {
  margin-top: 10vw;
}
.pet-image-wrap > img {
  max-width: 100%;
  min-width: 80%;
  max-height: 70vw;
  border-radius: 25px;
  box-shadow: 0 4px 8px #0004;
}

.panel {
  margin: 10vw 0;
  padding: 4vw;
  display: grid;
  grid-template: repeat(4, auto) / repeat(2, 1fr);
  row-gap: 20px;
  column-gap: 10px;
  font-size: 18px;
  font-weight: bold;
  background-color: #fffe;
  border-radius: 20px;
  justify-items: flex-start;
  box-shadow: 0 2px 5px #0002;
}

.item {
  overflow-wrap: anywhere;
  text-align: start;
  align-items: center;
  display: flex;
  gap: 8px;
}
.pet-item {
  font-weight: normal;
}
.item:last-child {
  grid-column-start: span 2;
}
.item > .ico-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
}
.ico-wrap > img {
  max-width: 20px;
}

.message-wrap {
  background: linear-gradient(133deg, #F8B029 0%, #F6923D 100%);
  border-radius: 20px;
  text-align: center;
  color: #FFFFFF;
  padding: 26px 43px;
  box-shadow: 0 2px 5px #0002;
}

.message {
  font-weight: 600;
  font-size: 20px;
  color: #FFFFFF;
  line-height: 24px;
  text-align: center;
  font-style: normal;
}
</style>



// WEBPACK FOOTER //
// src/views/checked_info/index.vue